import React from 'react';
import HeroSection from '../components/HeroSection';
import IntroPSESection from '../components/IntroPSESection';
// import SocialProofBar from '../components/SocialProofBar';
// ↑ Masqué temporairement le temps d'avoir une traction réelle (juin 2026).
//   Réactiver dès que les chiffres seront vérifiables (coops actives, planteurs, tonnes).
import HowItWorksSection from '../components/HowItWorksSection';
import FeaturesSection from '../components/FeaturesSection';
import BlockchainTrustSection from '../components/BlockchainTrustSection';
import TestimonialsSection from '../components/TestimonialsSection';
import CTASection from '../components/CTASection';
import MobileStickyCTA from '../components/MobileStickyCTA';
import Footer from '../components/Footer';

/**
 * Home — Refonte mobile-first (juin 2026).
 *
 * Avant : 9 sections (8 019 px, ~9,5 scrolls mobile).
 * Après : 4 sections + footer + sticky CTA mobile.
 *
 * Sections retirées (toujours accessibles via routes dédiées) :
 *  - REDDSection      → /redd-guide
 *  - CropsSection     → contenu marketing peu actionnable
 *  - PartnersSection  → à réintégrer quand on aura ≥ 5 logos vérifiés
 *  - PricingSection   → Phase 5 (refonte Gratuit/Premium/B2B)
 *  - ActivationCTA    → fusion avec CTASection (doublon)
 *  - SocialProofBar   → masqué tant qu'on n'a pas de traction vérifiable
 */
const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <IntroPSESection />
      {/* <SocialProofBar /> */}
      <HowItWorksSection />
      <FeaturesSection />
      <BlockchainTrustSection />
      <TestimonialsSection />
      <CTASection />
      <Footer />
      <MobileStickyCTA />
    </div>
  );
};

export default Home;
